import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Row, Table } from "reactstrap";
import { dateHelpers } from "../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function EmployeeTransactionEntryGrid(props) {
   const [data, setData] = useState(props.data ? props.data : null);

   useEffect(() => {
      if (data !== props.data) {
         setData(props.data);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.data]);

   return (
      <>
         <Row>
            <Table>
               <thead className="table-header">
                  <tr>
                     <th>
                        <span>Time Code</span>
                     </th>
                     <th>
                        <span>Start Date</span>
                     </th>
                     <th>
                        <span>End Date</span>
                     </th>
                     <th>
                        <span>Time DD:HH:MM</span>
                     </th>
                     <th>
                        <span>Type</span>
                     </th>
                     <th>
                        <span>Reason</span>
                     </th>
                     <th>
                        <span>Comments</span>
                     </th>
                     <th>
                        <span>Point Value</span>
                     </th>
                     <th></th>
                  </tr>
               </thead>
               <tbody>
                  {_.map(data, (x, index) => (
                     <tr key={index}>
                        <td className="data-cell">
                           <span>{x.timeCode}</span>
                        </td>
                        <td className="data-cell">
                           <span>{dateHelpers.toLongDateString(x.startDate)}</span>
                        </td>
                        <td className="data-cell">
                           <span>{dateHelpers.toLongDateString(x.endDate)}</span>
                        </td>
                        <td className="data-cell">
                           <span>{x.formatedHours}</span>
                        </td>
                        <td className="data-cell">
                           <span>{x.absenceType}</span>
                        </td>
                        <td className="data-cell">
                           <span>{x.absenceReason}</span>
                        </td>
                        <td className="data-cell">
                           <span>{x.notes}</span>
                        </td>
                        <td className="data-cell">
                           <span>{x.pointValue}</span>
                        </td>
                        <td className="data-cell">
                           <ButtonGroup>
                              <Button
                                 className="projectInfo"
                                 size="sm"
                                 title="edit"
                                 color="info"
                                 onClick={() => props.callback(x)}
                              >
                                 <FontAwesomeIcon className="whiteIcon" icon="edit" />
                              </Button>
                              <Button
                                 style={{ backgroundColor: "red" }}
                                 className="projectDanger"
                                 size="sm"
                                 title="Delete"
                                 onClick={() => props.deleteCallback(x.transactionId)}
                              >
                                 <FontAwesomeIcon className="whiteIcon" icon="times-circle" />
                              </Button>
                           </ButtonGroup>
                        </td>
                     </tr>
                  ))}
               </tbody>
            </Table>
         </Row>
      </>
   );
}
